import React from 'react'
import { graphql } from 'gatsby'

import Container from '../../../containers/Container'
import Wysiwyg from '../../Wysiwyg'
import * as style from './style.module.scss'

const AcfWysiwyg = ({ content }) => (
    <Container>
        <div className={style.wysiwyg}>
            <Wysiwyg content={content} />
        </div>
    </Container>
)

export default AcfWysiwyg

export const fragment = graphql`
    fragment AcfWysiwyg on WpPage_Acfflexiblefields_FlexibleFields_Wysiwyg {
        fieldGroupName
        content
    }
`
